import { styled } from 'styled-components';

import { useAuth } from 'apps-common/context/auth';
import { t } from 'translations';

import { FooterContainer } from '../../styles/containers';
import { Column, Row } from '../../styles/layout';
import { Paragraph } from '../../styles/text';
import { LogoutButton } from '../LogoutButton';
import { FooterProps } from './types';
import { WebsiteLinks } from './WebsiteLinks';

const LogoutButtonContainer = styled.div`
  margin-left: 20px;
`;

export const DesktopFooter = ({ onLinkClick, showLogout }: FooterProps) => {
  const { logout } = useAuth();
  return (
    <FooterContainer style={{ gap: '20px' }}>
      <Row $wrap="nowrap" style={{ width: '100%', justifyContent: 'space-between' }}>
        <Column style={{ alignItems: 'flex-start', width: '40%' }}>
          <Paragraph data-test="footer-year" $color="white2" $fontSize="small">
            {t('membership_footer_all_rights_reserved_dynamic', {
              year: new Date().getFullYear(),
            })}
          </Paragraph>
          <Paragraph $color="white2" $fontSize="small" $textAlign="left">
            {t('membership_footer_trademarks')}
          </Paragraph>
        </Column>
        <Row style={{ width: '60%' }} $wrap="nowrap">
          <WebsiteLinks onLinkClick={onLinkClick} />
          {showLogout && (
            <LogoutButtonContainer>
              <LogoutButton onClick={() => logout()} />
            </LogoutButtonContainer>
          )}
        </Row>
      </Row>
    </FooterContainer>
  );
};
